
let mainPicture = document.getElementById("lightSlider-s");
  let modalContainer = document.getElementById("myModal");
  let zoomInbtn = document.getElementById("zoomInbtn");
  let result = document.getElementById("zoomWindow");
  let modalImage = document.getElementById("zoomModal");
  let modalWholeImage = document.getElementsByTagName("BODY")[0];
  var clostbtn = document.getElementById("closebtn");
  var transformOffset = 0;
  let lens = document.createElement("DIV");

  let zoombtn = document.getElementById("zoom-btnId");
  
  var drag = false;
  var globalSkipCounter = 0;
  var globalSkipRate = 2;
  var aspectRatio = 1;
  var zoomSize = 3000;
  var maxZoomSize = 3000;
  var clickTimes = 0;
  let newPosX = 0, newPosY = 0, startPosX = 0, startPosY = 0, lastPosX = 0, lastPosY = 0, modalHeight = 0, modalWidth = 0, maxMoveX=0, maxMoveY=0;
  var signX = '-', signY = '-';

  mainPicture.addEventListener("click", zoomInHandler)
  zoombtn.addEventListener("click", zoomInHandler)

  function zoomInHandler() {
   let target = mainPicture.querySelector(".active")?.querySelector("img, video");
  if (!target) return; // If no target is found, simply return

  if (target.tagName.toLowerCase() === "video") {
    // If the target is a video, attempt to play it in full screen
    if (target.requestFullscreen) {
      target.requestFullscreen(); // W3C API
    } else if (target.webkitRequestFullscreen) {
      target.webkitRequestFullscreen(); // Safari
    } else if (target.mozRequestFullScreen) {
      target.mozRequestFullScreen(); // Firefox
    } else if (target.msRequestFullscreen) {
      target.msRequestFullscreen(); // IE/Edge
    }
    target.play(); // Play the video after entering full screen
  } else {
    var new_src = target.src.split("?")[0];
    target.src = new_src;
    aspectRatio = target.naturalHeight / target.naturalWidth;
    modalImage.style.backgroundImage = "url('" + target.src + "')";
    modalContainer.style.display = "block";
  }
}

  clostbtn.addEventListener("click",()=>{
    clickTimes = 0;
    drag = false;
    $('body').css("overflow", "visible");
    modalContainer.style.display = "none";
    modalImage.style.backgroundSize = "contain";
    modalImage.style.backgroundPosition = "center";
    zoomInbtn.style.display = "block";
    // modalImage.removeEventListener('mousedown', mouseDownHandler);
    modalImage.removeEventListener('touchstart', touchstartHandler);
  })

  function modalMove(e) {
      if(globalSkipRate > globalSkipCounter){globalSkipCounter += 1; return;}
      else{globalSkipCounter = 0;}
      drag = true;
      // calculate the new position
      newPosX = (startPosX - e.clientX);
      newPosY = (startPosY - e.clientY);
      newPosX = newPosX > 0 ? newPosX : 0;
      newPosY = newPosY > 0 ? newPosY : 0;
      var maxMoveX = zoomSize - modalImage.offsetWidth;
      var maxMoveY = zoomSize*aspectRatio - modalImage.offsetHeight;
      newPosX = newPosX < maxMoveX ? newPosX : maxMoveX;
      newPosY = newPosY < maxMoveY ? newPosY : maxMoveY;
      // set the element's new position:
      modalImage.style.backgroundPosition = "-"+(newPosX) + "px -" + (newPosY) + "px";

      // with each move we also want to update the start X and Y
      lastPosX = newPosX;
      lastPosY = newPosY;
  }

  function mouseDownHandler(e){
          e.preventDefault();
          e.stopPropagation();
          drag = false;
          // get the starting position of the cursor
          startPosX = e.clientX + lastPosX;
          startPosY = e.clientY + lastPosY;
          
          modalImage.addEventListener('mousemove', modalMove);
    
          modalWholeImage.addEventListener('mouseup', function mouseUpHandler(){
              modalImage.removeEventListener('mousemove', modalMove);
              modalWholeImage.removeEventListener('mouseup', mouseUpHandler);
          });
  }
    function touchModalMove(e) {
      if(globalSkipRate > globalSkipCounter){globalSkipCounter += 1; return;}
      else{globalSkipCounter = 0;}
      var touch = e.touches[0];
      var x = touch.pageX;
      var y = touch.pageY;
      
      newPosX = maxMoveX > 0 ? startPosX - x : startPosX + x;
      newPosY = maxMoveY > 0 ? startPosY - y : startPosY + y;
      newPosX = newPosX > 0 ? newPosX : 0;
      newPosY = newPosY > 0 ? newPosY : 0;
      var positiveMaxMoveX = maxMoveX;
      var positiveMaxMoveY = maxMoveY;
      if(maxMoveX < 0){
        positiveMaxMoveX = modalImage.offsetWidth - zoomSize;
        signX = '';
      }
      else{
        signX = '-';
      };
      
      if(maxMoveY < 0){
        positiveMaxMoveY = modalImage.offsetHeight - zoomSize*aspectRatio;
        signY = '';
      }
      else{
        signY = '-';
      };
      
      newPosX = newPosX < positiveMaxMoveX ? newPosX : positiveMaxMoveX;
      newPosY = newPosY < positiveMaxMoveY ? newPosY : positiveMaxMoveY;
      modalImage.style.backgroundPosition = signX + (newPosX) + "px " + signY + (newPosY) + "px";
  }
  
  function touchstartHandler(e){
          // e.preventDefault();
          e.stopPropagation();
          maxMoveX = zoomSize - modalImage.offsetWidth;
          maxMoveY = zoomSize*aspectRatio - modalImage.offsetHeight;
          $('body').css("overflow", "hidden");
          // get the starting position of the cursor
          var touch = e.touches[0];
          startPosX = maxMoveX > 0 ? touch.pageX + lastPosX : lastPosX - touch.pageX;
          startPosY = maxMoveY > 0 ? touch.pageY + lastPosY : lastPosY - touch.pageY;
          
          modalImage.addEventListener('touchmove', touchModalMove);
          $(modalImage).on('touchend touchcancel',function touchendHandler(){
              // with each move we also want to update the start X and Y
              lastPosX = newPosX;
              lastPosY = newPosY;
              modalImage.removeEventListener('touchmove', touchModalMove);
              modalImage.removeEventListener('touchend', touchendHandler);
          });
  }
  function zoomClickHandler(e){
    if(drag) {
      return;
    }
    modalWidth = modalImage.offsetWidth;
    modalHeight = modalImage.offsetHeight;
    
    if(!clickTimes){
        $("#zoomInbtn").fadeOut();
        clickTimes = 1;
        if(modalWidth * 2 < maxZoomSize){
          zoomSize = modalWidth * 2;
          modalImage.style.backgroundSize = zoomSize + "px";
        }
        else{
          modalImage.style.backgroundSize = maxZoomSize + "px";
        }
        lastPosX = zoomSize>modalWidth?(zoomSize - modalWidth)/2 : (modalWidth - zoomSize)/2;
        lastPosY = zoomSize*aspectRatio>modalHeight?(zoomSize*aspectRatio - modalHeight)/2 : (modalHeight - zoomSize*aspectRatio)/2;
        modalImage.addEventListener('mousedown', mouseDownHandler)
        modalImage.addEventListener('touchstart', touchstartHandler)
    }else{
        clickTimes = 0;
        modalImage.style.backgroundSize = "contain";
        modalImage.style.backgroundPosition = "center";
        modalImage.removeEventListener('mousedown', mouseDownHandler);
        modalImage.removeEventListener('touchstart', touchstartHandler);
    }
  }
  
  modalImage.addEventListener("click", zoomClickHandler);
  zoomInbtn.addEventListener("click", zoomClickHandler);


  function getCursorPos(e) {
    var a, x = 0, y = 0;
    e = e || window.event;
    /*get the x and y positions of the image:*/   
    a = mainPicture.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x : x, y : y};
  }

